import React from 'react';

// Both icons forward through any extra props (data-testid, aria-label, onClick, etc.)
// so the shared <AchievementBadges> row can attach `data-testid="achievement-badge-{key}"`
// and accessible labels directly onto the <svg>.
export const RavenIcon = ({ size = 20, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}
  >
    <path d="M22 2L15 22L11 13L2 9L22 2Z" /><path d="M11 13L15 22" />
  </svg>
);

export const SkaldIcon = ({ size = 20, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}
  >
    <path d="M8 4V20 M8 8L16 12 M8 14L16 18" />
  </svg>
);

// Watchman badge — a Norse shield with a central boss. Awarded when a
// reporter's hazard is confirmed "Still Here" by three fellow walkers.
export const WatchmanIcon = ({ size = 20, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}
  >
    <path d="M12 2L4 5V11C4 15.5 7.5 19.5 12 22C16.5 19.5 20 15.5 20 11V5L12 2Z" />
    <circle cx="12" cy="11" r="2.5" />
  </svg>
);

// Trail Scout — a runic compass rose. Awarded after five distinct
// Scout-Needed trails have been verified by this walker.
export const TrailScoutIcon = ({ size = 20, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 3L14 12L12 21L10 12Z" />
    <path d="M3 12L21 12" />
  </svg>
);

// Master Scout — a five-pointed rune-star crown. Awarded after
// twenty-five distinct verified scouts.
export const MasterScoutIcon = ({ size = 20, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...rest}
  >
    <path d="M12 2L14.6 8.5L21.5 9L16.2 13.6L17.8 20.5L12 16.9L6.2 20.5L7.8 13.6L2.5 9L9.4 8.5L12 2Z" />
  </svg>
);
